import { lazyNamed } from 'src/utils/lazyNamed.ts';

export const ReferencePerAdmedia = {
  List: lazyNamed(() => import('./containers/List/index.tsx'), 'ReferencePerAdmediaList'),
  Edit: lazyNamed(() => import('./containers/Edit/index.tsx'), 'ReferencePerAdmediaEdit'),
};
